export const STARTED_LOADING_GUIDE = 'STARTED_LOADING_GUIDE';
export const SUCCESS_LOADING_GUIDE = 'SUCCESS_LOADING_GUIDE';
export const FAILED_LOADING_GUIDE = 'FAILED_LOADING_GUIDE';
export const UPDATE_GUIDE = 'UPDATE_GUIDE';
